<template>
  <v-layout column align-center>
    <v-flex class="mb-2" style="width: 30px">
      <v-card
        v-for="(mask, index) in masks"
        :key="mask.label"
        class="pa-2 btn"
        :class="{ selected: index === selectedMaskIndex }"
        @click="selectMask(index)"
      >
        <span class="font-weight-black">{{ mask.mk_label }}</span>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { maskTypesMixin } from "@/mixins/forms/masks/maskTypesMixin";
import { mapActions } from "vuex";
export default {
  name: "MaskManagement",

  mixins: [maskTypesMixin],

  computed: {
    disabled() {
      return this.$store.getters.isManholeMasksTabDisabled;
    },
    masks() {
      return this.$store.getters.getManholeMasks;
    },
    selectedMaskIndex() {
      return this.$store.getters.getSelectedMaskIndex;
    }
  },

  methods: {
    ...mapActions([
      "setMasksTabSideSection",
      "setSelectedDuctEntryIndex",
      "setSelectedMaskIndex",
      "setMasksTabLoading",
      "editMask"
    ]),

    selectMask(maskIndex) {
      this.setMasksTabLoading(true);
      this.setSelectedMaskIndex(maskIndex);
      this.setSelectedDuctEntryIndex(undefined);
      this.setMasksTabSideSection("toolbar");
    },

    nextMaskLetter() {
      let lastMaskLetter = this.masks[this.masks.length - 1].mk_label;
      return String.fromCharCode(lastMaskLetter.charCodeAt(0) + 1);
    }
  }
};
</script>

<style scoped>
.btn:hover {
  background-color: rgba(79, 162, 183, 0.1);
}
.btn.selected {
  background-color: rgba(79, 162, 183, 0.2);
  pointer-events: none;
}
.v-btn {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Masks/Masks/MaskManagement.vue